import { render, staticRenderFns } from "./adjust-policy.vue?vue&type=template&id=c298bd86&scoped=true&"
import script from "./adjust-policy.vue?vue&type=script&lang=js&"
export * from "./adjust-policy.vue?vue&type=script&lang=js&"
import style0 from "./adjust-policy.vue?vue&type=style&index=0&id=c298bd86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c298bd86",
  null
  
)

export default component.exports